import PropTypes from "prop-types";
import React from "react";
import { useState } from "react";
import { Box, Switch, Text } from "@mantine/core";
import { useStylesTriggerHelp } from "../utils/mantine/useStylesTriggerHelp";

const TriggerHelp = ({
  helpIsActive,
  isNearBottom,
  handleHelpTriggerClick,
}) => {
  //css classes
  const { classes: classesTriggerHelp } = useStylesTriggerHelp();
  const [checked, setChecked] = useState(helpIsActive);
  return (
    <>
      {!isNearBottom && (
        <Box className={classesTriggerHelp.trigger}>
          <Text className="text">
            Help{" "}
            <Text className="textBold" component="span">
              Off / On
            </Text>
          </Text>
          <Switch
            size="lg"
            checked={checked}
            onChange={(event) => {
              setChecked(event.currentTarget.checked);
              handleHelpTriggerClick(event.currentTarget.checked);
            }}
          />
        </Box>
      )}
    </>
  );
};

TriggerHelp.propTypes = {
  helpIsActive: PropTypes.bool.isRequired,
  isNearBottom: PropTypes.bool.isRequired,
  handleHelpTriggerClick: PropTypes.func,
};

export default TriggerHelp;
